import { render, staticRenderFns } from "./TransferRequestInfo.vue?vue&type=template&id=1f61784c&scoped=true"
import script from "./TransferRequestInfo.vue?vue&type=script&lang=js"
export * from "./TransferRequestInfo.vue?vue&type=script&lang=js"
import style0 from "./TransferRequestInfo.vue?vue&type=style&index=0&id=1f61784c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f61784c",
  null
  
)

export default component.exports